// extracted by mini-css-extract-plugin
module.exports = {"srtAddOrderContainer":"Booking-components-AddOrderDialog-___stylesAddOrder__srtAddOrderContainer___2-bY5"};
    if(module.hot) {
      // 1752586167122
      var cssReload = require("/builds/SilverAgent/SilverAgent/ui-parent-r2/silveragent-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"build/","hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  